import Vue from 'vue';

export default Vue.component('my-account-config', {

    props: {
        template:
            {
                type: String,
                default: '#vue-my-account-config',
            }
    },

    data() {
        return {
        };
    },

    /**
     * Initialise the account settings modal
     */
    mounted() {
    },

    computed: {},

    methods: {

    },

});
